﻿/* eslint-disable */
/// <reference types="jquery" />
/// <reference types="react" />
/// <reference types="react-dom" />

// Tell babel to include the polyfills.
import "@babel/polyfill";

export * from './Scripts/SmartTools/index';

import * as $ from 'jquery';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { UserAnalytics } from '@metricell/user-analytics';

// jQuery needs to be defined globally
// We need to also export React/ReactDOM for views to instantiate a base react component
declare global {
    interface Window {
        $: any;
        jQuery: any;
        React: any;
        ReactDOM: any;
        UserAnalytics: any;
    }
}

window.$ = $;
window.jQuery = $;
window.React = React;
window.ReactDOM = ReactDOM;
window.UserAnalytics = UserAnalytics;

import 'expose-loader?jQuery!jquery';
import 'signalr';
/* eslint-enable */
